<div class="flex flex-col gap-4">
  <lib-link
    [link]="ctaLink()"
    [queryParams]="queryParams()"
    [queryParamsHandling]="'merge'"
    (onClick)="ctaClick.emit()"
  >
    <div class="flex flex-col gap-4">
      <ng-content select="beforeCta" />
      <div class="px-5">
        <button class="button text-center w-full min-w-44 text-sm" [ngClass]="ctaClasses()">
          {{ ctaLabel() }}
        </button>
      </div>
    </div>
  </lib-link>
  <ng-content select="afterCta" />
</div>
